/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingIdQueryResponse, GetApiBookingIdPathParams, GetApiBookingIdQueryParams } from "../entities/GetApiBookingId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBookingId } from "../api/getApiBookingId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBookingIdQueryKey = (id: GetApiBookingIdPathParams["id"] | undefined, params: GetApiBookingIdQueryParams) => [{ url: '/api/booking/:id', params: {id:id} }, ...(params ? [params] : [])] as const

export type GetApiBookingIdQueryKey = ReturnType<typeof getApiBookingIdQueryKey>

export function getApiBookingIdQueryOptions(id: GetApiBookingIdPathParams["id"] | undefined, params: GetApiBookingIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBookingIdQueryKey(id, params)
        return queryOptions<GetApiBookingIdQueryResponse, ResponseErrorConfig<Error>, GetApiBookingIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBookingId(id!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить детали записи
 * @summary Получить запись по ID
 * {@link /api/booking/:id}
 */
export function useGetApiBookingId<TData = GetApiBookingIdQueryResponse, TQueryData = GetApiBookingIdQueryResponse, TQueryKey extends QueryKey = GetApiBookingIdQueryKey>(id: GetApiBookingIdPathParams["id"] | undefined, params: GetApiBookingIdQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBookingIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBookingIdQueryKey(id, params)
         

         const query = useQuery({
          ...getApiBookingIdQueryOptions(id, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}